import React from "react";

const SUPPORT_EMAIL = "cost@averlynxstore.one";

export function PolicyText({ children }) {
  const parts = String(children).split(SUPPORT_EMAIL);

  return (
    <>
      {parts.map((part, index) => (
        <React.Fragment key={`${part}-${index}`}>
          {part}
          {index < parts.length - 1 ? (
            <a href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a>
          ) : null}
        </React.Fragment>
      ))}
    </>
  );
}

export default SUPPORT_EMAIL;
